import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const cerebralPalsy: AnswerPathTreeNode = {
  path: 'cerebralPalsy',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCerebralPalsyDetails }],
};
